import { render, staticRenderFns } from "./UserNoteModal.vue?vue&type=template&id=1561e49a&scoped=true&"
import script from "./UserNoteModal.vue?vue&type=script&lang=js&"
export * from "./UserNoteModal.vue?vue&type=script&lang=js&"
import style0 from "./UserNoteModal.vue?vue&type=style&index=0&id=1561e49a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1561e49a",
  null
  
)

export default component.exports